export enum EEntityType {
  Newbuilding = 'newbuilding',
  OfferCommercial = 'offerCommercial',
  OfferResidental = 'offerResidental',
  OfferSuburban = 'offerSuburban',
}
